var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import SplashLogger from "utils/SplashLogger";
import { getFrontendSpecficProps, getReferrerProps, isGuest, trackCallbackMethodToSentry } from "../helpers/utils";
import * as Sentry from "@sentry/browser";
import { initalizeTrackServerSideApiThrottler, pushTrackServerSideEventsViaApiThrottler } from "../helpers/bufferTrackApi";
import { BufferTrackGuestEvents } from "../helpers/bufferTrackGuestEventsApi";
var loggerName = "ServerSideEvents";
var ServerSideEvents = /** @class */ (function () {
    function ServerSideEvents() {
        var _this = this;
        this.init = function () {
            _this.bufferTrackGuestEvents = new BufferTrackGuestEvents();
            initalizeTrackServerSideApiThrottler();
        };
        this.trackServerSide = function (_event, properties, callbackMethod, onlyCleverTap) { return __awaiter(_this, void 0, void 0, function () {
            var data;
            var _a, _b;
            return __generator(this, function (_c) {
                try {
                    if (!this.isEventNameValid(_event)) {
                        this.logEventNameInvalidError({
                            eventName: _event,
                            methodName: "trackServerSide",
                            properties: properties,
                            callbackMethod: callbackMethod,
                            onlyCleverTap: onlyCleverTap
                        });
                        return [2 /*return*/];
                    }
                    Object.assign(properties, getFrontendSpecficProps());
                    properties["$current_url"] = typeof window !== "undefined" ? window.location.href : "Unknown";
                    properties = __assign(__assign({}, properties), getReferrerProps());
                    data = { event: _event,
                        properties: properties,
                        only_mixpanel: true,
                        only_clevertap: false,
                        client_id: (_a = window.trackerProperties) === null || _a === void 0 ? void 0 : _a.clientId
                    };
                    if (onlyCleverTap === true) {
                        data.only_mixpanel = false;
                        data.only_clevertap = true;
                    }
                    pushTrackServerSideEventsViaApiThrottler(data);
                }
                catch (e) {
                    if (WebCoreUIConfig.env == "development" || WebCoreUIConfig.env == "staging") {
                        SplashLogger.error(loggerName, e.message);
                    }
                    else {
                        SplashLogger.error(loggerName, 'SOMETHING WENT WRONG -- trackServerSide');
                    }
                    Sentry.captureException(e, {
                        tags: {
                            event: _event,
                            analyticsId: (_b = window.trackerProperties) === null || _b === void 0 ? void 0 : _b.analyticsId,
                        },
                        level: "error",
                    });
                }
                finally {
                    if (callbackMethod && typeof (callbackMethod) === "function") {
                        trackCallbackMethodToSentry(callbackMethod, _event, "trackServerSide");
                        callbackMethod();
                    }
                }
                return [2 /*return*/];
            });
        }); };
        this.trackEventsForGuests = function (event, properties, meta) { return __awaiter(_this, void 0, void 0, function () {
            var data;
            var _a;
            return __generator(this, function (_b) {
                try {
                    if (!isGuest())
                        return [2 /*return*/];
                    if (!this.isEventNameValid(event)) {
                        this.logEventNameInvalidError({
                            eventName: event,
                            methodName: "trackEventsForGuests",
                            properties: properties,
                            meta: meta
                        });
                        return [2 /*return*/];
                    }
                    if (!properties['time']) {
                        properties['time'] = new Date();
                    }
                    properties['systemTimeDifferenceInMs'] = window.systemTimeDifferenceInMs;
                    Object.assign(properties, getFrontendSpecficProps());
                    properties["Page Url"] = typeof window !== "undefined" ? window.location.href : "Unknown";
                    properties = __assign(__assign({}, properties), getReferrerProps());
                    data = {
                        event_name: event,
                        properties: properties,
                        meta: {
                            send_datadump: (meta === null || meta === void 0 ? void 0 : meta.send_datadump) || true,
                            send_mixpanel: (meta === null || meta === void 0 ? void 0 : meta.send_mixpanel) || false,
                            send_clevertap: (meta === null || meta === void 0 ? void 0 : meta.send_clevertap) || false,
                        }
                    };
                    this.bufferTrackGuestEvents.pushTrackGuestEventsViaApiThrottler(data);
                }
                catch (e) {
                    if (WebCoreUIConfig.env == "development" || WebCoreUIConfig.env == "staging") {
                        SplashLogger.error(loggerName, e.message);
                    }
                    else {
                        SplashLogger.error(loggerName, 'SOMETHING WENT WRONG -- trackEventsForGuests');
                    }
                    Sentry.captureException(e, {
                        tags: {
                            event: event,
                            analyticsId: (_a = window.trackerProperties) === null || _a === void 0 ? void 0 : _a.analyticsId,
                        },
                        level: "error",
                    });
                }
                return [2 /*return*/];
            });
        }); };
        this.init();
        window.trackServerSide = this.trackServerSide;
        window.trackEventsForGuestsCore = this.trackEventsForGuests;
    }
    ServerSideEvents.prototype.isEventNameValid = function (eventName) {
        return !!(eventName === null || eventName === void 0 ? void 0 : eventName.trim());
    };
    ServerSideEvents.prototype.logEventNameInvalidError = function (_a) {
        var _b;
        var eventName = _a.eventName, methodName = _a.methodName, properties = _a.properties, callbackMethod = _a.callbackMethod, meta = _a.meta, onlyCleverTap = _a.onlyCleverTap;
        var errorMessage = "Event is null, blank, or empty in ".concat(methodName);
        SplashLogger.error(loggerName, errorMessage);
        var tags = {
            eventName: eventName,
            methodName: methodName,
            onlyCleverTap: onlyCleverTap,
            analyticsId: (_b = window.trackerProperties) === null || _b === void 0 ? void 0 : _b.analyticsId,
        };
        var extra = { properties: properties, callbackMethod: callbackMethod, meta: meta };
        Sentry.captureMessage(errorMessage, {
            tags: tags,
            extra: extra,
            level: "error",
        });
    };
    return ServerSideEvents;
}());
export { ServerSideEvents };
